import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const Gallery = () => {
  // State to manage the modal visibility and selected image
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  // Image data for the gallery
  const images = [
    'img/gallery/om-sai-pg-3.jpg',
    'img/gallery/om-sai-pg-4.jpg',
    'img/gallery/om-sai-pg-room.jpg',
    'img/gallery/om-sai-pg-room1.jpg',
    'img/gallery/om-sai-pg-room4.jpg',
    'img/gallery/om-sai-pg-room8.jpg',
    'img/gallery/om-sai-pg-room9.jpg',
    'img/gallery/om-sai-pg-room10.jpg',
    'img/gallery/om-sai-pg-room11.jpg',
    'img/gallery/om-sai-pg-room12.jpg',
    'img/gallery/om-sai-pg-room19.jpg',
    'img/gallery/om-sai-pg1.jpg',
    'img/gallery/om-sai-pg-room15.jpg',
    'img/gallery/om-sai-pg7.jpg',
    'img/gallery/om-sai-pg5.jpg'
  ];

  // Function to toggle the modal and handle image selection
  const toggleModal = (image) => {
    if (isModalOpen && selectedImage === image) {
      // If the modal is already open and same image is clicked, close it
      setIsModalOpen(false);
      setSelectedImage('');
    } else {
      // Otherwise, open the modal and set the selected image
      setSelectedImage(image);
      setIsModalOpen(true);
    }
  };

  return (

    <>
<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 |Gallery | Om Sai PG | PG Near Kharadi Bypass | Wadgaon Sheri PG | PG in in Chandan Nagar|
Hostels in Kharadi
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG in Pune, PG in Kharadi, PG with food in Pune, PG for students in Kharadi, PG for females in Pune, PG for males in Pune, Om Sai PG Kharadi, Girls Hostels in Kharadi,"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>


    <section class="section-breadcrumb">
        <div class="rx-breadcrumb-image bg-img1">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Gallery</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Gallery</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li>Gallery</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section className="section-gallery padding-tb-100">
      <div className="container">
        <div className="row mb-minus-24">
          <div className="col-12">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img src="img/banner/left-shape.svg" alt="banner-left-shape" className="svg-img left-side" />
                Grand Ambiance
                <img src="img/banner/right-shape.svg" alt="banner-right-shape" className="svg-img right-side" />
              </p>
              <h4>
                Our <span>Gallery</span>
              </h4>
            </div>
          </div>

          {images.map((imgSrc, index) => (
            <div
              className="col-lg-4 col-sm-6 col-12 rx-575-50 mb-24"
              key={index}
            >
              <figure className="rx-gallery-card">
                <a className="rx-gallery-img" href="#" onClick={() => toggleModal(imgSrc)}>
                  <img src={imgSrc} alt={`gallery-${index + 1}`} />
                </a>
              </figure>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for image view */}
      {isModalOpen && (
        <div className="modal" onClick={() => toggleModal(selectedImage)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={() => toggleModal(selectedImage)}>&times;</span>
            <img src={selectedImage} alt="Selected" className="modal-image" />
          </div>
        </div>
      )}
    </section>
    </>
  );
};

export default Gallery;
